import gql from 'graphql-tag'

export default gql`
    mutation Authenticate($username: String!, $password: String!){
      authenticateUser(username: $username, password: $password){
        token
        user{
          user_id
          first_name
          last_name
          user_role_id
          user_role{
            description
          }
          password_change_required
          simple_permissions
          office_id
        }
      }
    }
`